import { MessageCircle, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { Divider } from "./Ornaments";
import { FAMILIES, PHONES } from "./data";

const Rsvp = () => (
    <section
        id="rsvp"
        data-testid="rsvp-section"
        className="relative py-24 sm:py-36"
    >
        <div className="mx-auto max-w-5xl px-6 text-center">
            <Reveal>
                <p className="font-cinzel text-[11px] font-semibold uppercase tracking-[0.5em] text-gold">
                    With Best Compliments &amp; RSVP
                </p>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-6 font-royal text-3xl font-medium text-ivory sm:text-4xl">
                    Soliciting Your Gracious Presence
                </h2>
            </Reveal>
            <Reveal delay={0.15}>
                <Divider className="mt-8" />
            </Reveal>

            <Reveal delay={0.2}>
                <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
                    {FAMILIES.map((f) => (
                        <span
                            key={f}
                            data-testid={`family-badge-${f.toLowerCase()}`}
                            className="rounded-full border border-gold/30 bg-royal-card/60 px-5 py-2 font-cinzel text-[10px] font-semibold uppercase tracking-[0.3em] text-sand transition-colors duration-500 hover:border-gold/70 hover:text-gold"
                        >
                            {f}
                        </span>
                    ))}
                </div>
            </Reveal>

            <div className="mt-14 grid gap-5 sm:grid-cols-2">
                {PHONES.map((p, i) => {
                    const digits = p.tel.replace("+91", "");
                    return (
                        <Reveal key={p.tel} delay={0.25 + i * 0.08}>
                            <div
                                data-testid={`phone-contact-${digits}`}
                                className="group flex items-center justify-between gap-4 rounded-xl border border-gold/20 bg-royal-card/70 px-6 py-5 transition-colors duration-500 hover:border-gold/55"
                            >
                                <div className="text-left">
                                    <p className="font-royal text-xl font-semibold tracking-wide text-ivory">
                                        {p.number}
                                    </p>
                                </div>
                                <div className="flex gap-2.5">
                                    <a
                                        data-testid={`call-${digits}`}
                                        href={`tel:${p.tel}`}
                                        aria-label={`Call ${p.label}`}
                                        className="flex h-11 w-11 items-center justify-center rounded-full bg-gold text-obsidian transition-transform duration-500 hover:scale-110"
                                    >
                                        <Phone size={16} />
                                    </a>
                                    <a
                                        data-testid={`whatsapp-${digits}`}
                                        href={`https://wa.me/${p.wa}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label={`WhatsApp ${p.label}`}
                                        className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-all duration-500 hover:scale-110 hover:bg-gold/10"
                                    >
                                        <MessageCircle size={16} />
                                    </a>
                                </div>
                            </div>
                        </Reveal>
                    );
                })}
            </div>

            <Reveal delay={0.4}>
                <p className="mt-14 font-royal text-lg italic text-sand sm:text-xl">
                    With best compliments from —{" "}
                    <span className="font-semibold text-gold">All Relatives &amp; Friends</span>
                </p>
            </Reveal>
        </div>
    </section>
);

export default Rsvp;
